import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "material-icons-round"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["md-alert", [_ctx.variant, _ctx.icon ? 'icon' : '']])
  }, [
    (_ctx.icon)
      ? (_openBlock(), _createElementBlock("i", _hoisted_1, _toDisplayString(_ctx.icon), 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}